import React, { useEffect, useState } from 'react';
import { Coach } from '../model/Coach';
import { showMessage } from '../services/popup';
import { getCoaches } from '../services/service';
import { CoachComponent } from '../components/CoachComponent';

const SIZE = 20;

const CoachTab: React.FC = () => {
  const [page, setPage] = useState(0);
  const [coaches, setCoaches] = useState<Coach[]>([]);
  const [current, setCurrent] = useState<Coach | undefined>(undefined);
  const [pattern, setPattern] = useState('');

  const loadCoaches = async (p: number, currentPattern?: string) => {
    try {
      const c = await getCoaches(currentPattern ?? pattern, p * SIZE, SIZE + 1);
      setCoaches(c);
    } catch (e) {
      showMessage('Une erreur est survenue: ' + JSON.stringify(e));
    }
  };

  const hasNext = coaches.length > SIZE;
  const hasPrevious = page > 0;

  const movePage = (next: number) => {
    if (next >= 0) {
      setPage(next);
      loadCoaches(next);
    }
  };

  const search = () => {
    setPage(0);
    loadCoaches(0, pattern);
  };

  useEffect(() => {
    loadCoaches(0, '');
  }, []);

  if (current) {
    return (
      <div className="page-stack">
        <button className="ghost-btn" onClick={() => setCurrent(undefined)}>Retour liste coachs</button>
        <CoachComponent coach={current} />
      </div>
    );
  }

  return (
    <div className="page-stack">
      <section className="panel">
        <div className="toolbar-row">
          <input value={pattern} onChange={(e) => setPattern(e.target.value)} placeholder="Rechercher un coach" />
          <button className="primary-btn" onClick={search}>Rechercher</button>
          <div className="pager-inline">
            <button className="ghost-btn" disabled={!hasPrevious} onClick={() => movePage(page - 1)}>Precedent</button>
            <span>Page {page + 1}</span>
            <button className="ghost-btn" disabled={!hasNext} onClick={() => movePage(page + 1)}>Suivant</button>
          </div>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Nom</th>
                <th>Note</th>
                <th>Telephone</th>
                <th>Cours</th>
                <th>Etat</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {coaches.slice(0, SIZE).map((c, i) => (
                <tr key={i}>
                  <td className="mono">{c.id}</td>
                  <td>{c.firstname} {c.lastname}</td>
                  <td>{c.note}</td>
                  <td>{c.phoneNumber}</td>
                  <td>{c.specialities.map((s) => s.name).join(', ')}</td>
                  <td>
                    <span className={`pill ${c.state ? 'ok' : 'bad'}`}>{c.state ? 'Actif' : 'Inactif'}</span>
                  </td>
                  <td>
                    <button className="ghost-btn" onClick={() => setCurrent(c)}>Voir</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default CoachTab;
